// 요금제·사용량 API — 백엔드 kr.taplink.billing.BillingController
// 타입은 OpenAPI 계약에서 생성(DSN-3)
import type { Schemas } from "@taplink/api-client";
import { request } from "@taplink/web-shared";

/** monthlyPrice null = 견적(계약형) */
export type PlanSummary = Schemas["PlanSummary"];
/** limit null = 무제한 */
export type QuotaStatus = Schemas["QuotaStatus"];
/** features: ACCESS_CONTROL·DYNAMIC_QR·BRANDING_REMOVED */
export type Usage = Schemas["UsageResponse"];
/**
 * 풀 안의 **한 작업 공간**이 쓰는 양.
 *
 * ⚠️ `seats` 의 합이 풀 좌석 수와 다를 수 있다 — 풀은 사람을 중복 없이 세고
 *    이 값은 공간별로 센다. 같은 사람이 두 조직에 있으면 각 줄에 하나씩 잡힌다.
 */
export type PoolSpaceUsage = Schemas["PoolSpaceUsage"];

export const billingApi = {
  usage: () => request<Usage>("/billing/usage"),
  /** 공간별 내역 — "어디를 정리할지" 보여준다. `/usage` 는 총량만 준다 */
  spaces: () => request<PoolSpaceUsage[]>("/billing/usage/spaces"),
  plans: () => request<PlanSummary[]>("/billing/plans", { anonymous: true }),
};

/** 화면 표기용 한도 이름 */
export const QUOTA_LABELS: Record<string, string> = {
  LINKS_PER_MONTH: "이번 달 생성",
  ACTIVE_LINKS: "활성 링크",
  SEATS: "팀 좌석",
};

/** 숫자만 봐서는 알 수 없는 셈법을 덧붙인다 */
export const QUOTA_NOTES: Record<string, string> = {
  SEATS: "본인은 좌석을 쓰지 않습니다. 수락 대기 중인 초대는 좌석을 차지합니다.",
};
